// KEEP THIS FILE when removing template folder PLT-4427

import templatesMock from 'services/TemplateService/mock/templates.json';

export const filterTemplatesByCategory = (templates = [], filterCategory) =>
  (filterCategory && templates.filter((template) => {
    if (Array.isArray(template.category)) {
      const filteredCategories = template.category.filter((category) => (
        category === filterCategory
      ));
      return filteredCategories.length > 0;
    }
    return template && template.category === filterCategory;
  })
  ) || [];

export const filterTemplatesByTemplateType = (templates = [], templateTypes) => {
  const filteredItems = new Set([]);

  if (Array.isArray(templateTypes)) {
    templateTypes.forEach((templateType) => {
      templates.forEach((template) => {
        if (template.templateType === templateType) { filteredItems.add(template); }
      });
    });
  } else {
    const templateType = templateTypes;
    templates.forEach((template) => {
      if (template.templateType === templateType) { filteredItems.add(template); }
    });
  }

  return Array.from(filteredItems);
};

// Template List
export const ListTemplatesFromMockData = (templateTypes, filterCategory) => {
  const templates = templatesMock;
  const filteredByTemplate = templateTypes
    ? filterTemplatesByTemplateType(templates, templateTypes)
    : templates;
  const filteredByCategory = filterCategory
    ? filterTemplatesByCategory(filteredByTemplate, filterCategory)
    : filteredByTemplate;
  return filteredByCategory;
};

export const getTemplateCategories = (templateTypes) => {
  const templates = ListTemplatesFromMockData(templateTypes);
  const templateCategories = new Set([]);
  templates.forEach((template) => {
    if (Array.isArray(template.category)) {
      template.category.forEach((category) => {
        templateCategories.add(category);
      });
    } else {
      templateCategories.add(template.category);
    }
  });
  return Array.from(templateCategories);
};
